import React, { useEffect, useState } from 'react'
import { useQueryParams } from '@fs/zion-router'
import { InfoSheetPanel, useOverlay } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { useUser } from '@fs/zion-user'
import ShowChangeHistory from '../ui/ShowChangeHistory'
import TranscriptAlertBanner from './TranscriptAlertBanner'
import PersonsListSection from './PersonsListSection'
import { usePersonList } from '../../../../components/generic/personsList'
import BlankState from './BlankState'
import SignInBlankState from './SignInBlankState'
import FullText from '../../../fullText/FullText'
import useViewIndexPersonSelect from './useViewIndexPersonSelect'
import AddNamesPanel from '../../../fullText/components/addNamesPanel/AddNamesPanel'
import { ADD_NAME_PANEL_REFERRERS } from '../../../fullText/components/addNamesPanel/utils/utils'

export default function SelectPersonV2({ loading = false }) {
  const [t] = useTranslation()
  const { signedIn } = useUser()
  const [filterValue, setFilterValue] = useState('')
  const { query, setQuery } = useQueryParams()
  const { view } = query || {}
  const { personsListProps, showBlankState, showChangeHistory } = usePersonList({
    loading,
    filterValue,
  })
  personsListProps.onPersonSelect = useViewIndexPersonSelect()
  const fullTextOverlay = useOverlay({ initiallyOpen: view === 'fullText' })

  const handleViewTranscript = () => setQuery({ view: 'fullText' })
  const userClosedFullTextPanel = () => setQuery({ view: 'index' })

  // The single source of truth here is the query param
  const openFullTextOverlay = fullTextOverlay.open
  const closeFullTextOverlay = fullTextOverlay.close
  const fullTextOverlayIsOpen = fullTextOverlay.isOpen
  useEffect(() => {
    if (view === 'fullText' && !fullTextOverlayIsOpen) {
      openFullTextOverlay()
    } else if (view !== 'fullText' && fullTextOverlayIsOpen) {
      closeFullTextOverlay()
    }
  }, [view, fullTextOverlayIsOpen, openFullTextOverlay, closeFullTextOverlay])

  return (
    <>
      {signedIn ? (
        <>
          {/* Transcript Alert Banner */}
          <TranscriptAlertBanner handleViewTranscript={handleViewTranscript} />

          {showBlankState ? (
            <BlankState />
          ) : (
            <PersonsListSection
              filterValue={filterValue}
              onFilterChange={setFilterValue}
              personsListProps={personsListProps}
            />
          )}
        </>
      ) : (
        <>
          {showBlankState ? (
            <SignInBlankState />
          ) : (
            <PersonsListSection
              filterValue={filterValue}
              onFilterChange={setFilterValue}
              personsListProps={personsListProps}
            />
          )}
        </>
      )}

      {/* Change History */}
      {showChangeHistory && <ShowChangeHistory />}

      <AddNamesPanel referrer={ADD_NAME_PANEL_REFERRERS.BLANK_STATE} />
      <InfoSheetPanel
        title={t('transcript-alert-banner.view-names', 'View Names')}
        {...fullTextOverlay}
        close={userClosedFullTextPanel}
      >
        <FullText />
      </InfoSheetPanel>
    </>
  )
}
